import { Tag, baseApi } from './base'
import { Admin, CreateAdminDto } from '../models/admin.model'
import { cacher } from '@/utils/rtkQueryCacheUtils'

export const superAdminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    assignAdminLicenses: builder.mutation<Admin, { adminId: string; licenses: string[] }>({
      query: ({ adminId, licenses }) => ({ url: `super-admin/admins/${adminId}/licenses`, method: 'PATCH', body: { licenses } }),
      invalidatesTags: (_result, _error, { adminId }) => [{ type: Tag.ADMIN, id: adminId }, ...cacher.invalidatesList(Tag.ADMIN)()],
    }),
    createAdmin: builder.mutation<Admin, CreateAdminDto>({
      query: (body) => ({ url: 'super-admin/admins', method: 'POST', body }),
      invalidatesTags: cacher.invalidatesList(Tag.ADMIN),
    }),
    deleteAdmin: builder.mutation<string, string>({
      query: (adminId) => ({ url: `super-admin/admins/${adminId}`, method: 'DELETE' }),
      invalidatesTags: cacher.invalidatesList(Tag.ADMIN),
    }),
    getEstablishmentAdmins: builder.query<Admin[], string>({
      query: (establishmentId) => `/super-admin/establishments/${establishmentId}/admins`,
      providesTags: cacher.providesList(Tag.ADMIN),
    }),
  }),
  overrideExisting: false,
})
